export default __webpack_public_path__ + "locales/lo-LA/Article.json?hash=8ba14f648110dbbc8aa9bb44f7a3dac2";